import { AvailabilityState } from '@notino/shared/definitions/types';

import { useProductDetailContext } from '@containers/ProductDetailContainer/ProductDetailContext';

const REVIEWS_MIN_COUNT = 2;
const RATING_MIN_COUNT = 3;

export const useShouldShowReviewPage = (
  textReviewCount: number,
  ratingSummary: number
) => {
  const { currentVariant } = useProductDetailContext();

  const isNotDisabled =
    currentVariant.availability.state !== AvailabilityState.Disabled;

  return (
    textReviewCount >= REVIEWS_MIN_COUNT &&
    ratingSummary >= RATING_MIN_COUNT &&
    isNotDisabled
  );
};
